// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once admin JS imports sp apps directly.
import { setTargetVisibility } from "#/admin/legacy/forms/target-visibility.js";
import { settleMount } from "#ce/framework/mount-ready";

const CONTAINER_SELECTOR = '[data-behaviour~="polymorphic-select"]';
const CONTROL_SELECTOR = "select, sp-select";

/** Shows the option group of the picked class and disables the selects of the other groups. */
export function updateClassSelection(event) {
  const container = event.target.closest(CONTAINER_SELECTOR);
  const control = container?.querySelector(CONTROL_SELECTOR);

  if (event.target !== control) {
    return;
  }

  for (const group of container.querySelectorAll("[data-polymorphic-select-class]")) {
    const selected = group.dataset.polymorphicSelectClass === control.value;

    setTargetVisibility(group, selected);

    group.querySelectorAll(CONTROL_SELECTOR).forEach(function setDisabledState(select) {
      select.disabled = !selected;
    });
  }
}

async function initializeClassSelection(container) {
  const control = container.querySelector(CONTROL_SELECTOR);

  if (await settleMount(control)) {
    control.dispatchEvent(new Event("change", { bubbles: true }));
  }
}

/** Announces each polymorphic select's class control once it has mounted; resolves when all are done. */
export function initializePolymorphicSelects() {
  return Promise.all(Array.from(document.querySelectorAll(CONTAINER_SELECTOR), initializeClassSelection));
}
